import styled from "@emotion/styled";
import { Box, Card, Container, Fab, Grid, Skeleton, Typography } from "@mui/material";
import axios from "axios";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";

import AddIcon from '@mui/icons-material/Add';
import PageTitle from "components/PageTitle";

export default function Home() {

  const navigate = useNavigate();

  const [listForCreditor, setListForCreditor] = useState(null);
  const [listForDebtor, setListForDebtor] = useState(null);
  
  useEffect(() => {
    axios.get("/api/note/group")
    .then(res => {
      setListForCreditor(res.data.listForCreditor);
      setListForDebtor(res.data.listForDebtor);
    });
  }, []);

  return (
    <Container>
      <PageTitle>🏡&nbsp;Home</PageTitle>

      <GroupContainer>
        <div>
          <GroupLabel>💸&nbsp;받아야 하는</GroupLabel>
          <Grid container flexDirection="column" gap="10px">
            {listForCreditor ?
              listForCreditor.length > 0 ?
                listForCreditor.map(item => {
                  return (
                    <NoteGroup
                      noteId={item.noteId}
                      noteName={item.noteName}
                      balance={item.balance}
                      otherUser={`FROM. ${item.debtorName}`}
                    />
                  )
                })
                :
                <EmptyList text="받을 돈이 없습니다."/>
              :
              <NoteGroupSkeleton/>
            }
          </Grid>
        </div>

        <div>
          <GroupLabel>💸&nbsp;갚아야 하는</GroupLabel>
          <Grid container flexDirection="column" gap="10px">
            {listForDebtor ?
              listForDebtor.length > 0 ? 
                listForDebtor.map(item => {
                  return (
                    <NoteGroup
                      noteId={item.noteId}
                      noteName={item.noteName}
                      balance={item.balance}
                      otherUser={`TO. ${item.creditorName}`}
                    />
                  );
                })
                :
                <EmptyList text="갚을 돈이 없습니다."/>
              :
              <NoteGroupSkeleton/>
            }
          </Grid>
        </div>
      </GroupContainer>

      <Fab
        color="primary" 
        aria-label="add" 
        sx={{position: "fixed", bottom: "10px", right: "10px"}}
        onClick={() => navigate("/note/add")}
      >
        <AddIcon/>
      </Fab>
    </Container>
  )
}

function NoteGroup({noteId, noteName, balance=0, otherUser}) {

  const navigate = useNavigate();

  return (
    <Card
      variant="outlined"
      onClick={() => navigate(`/note/${noteId}`)}
      sx={{
        height: "95px",
        padding: "1rem",
        boxSizing: "border-box",
        cursor: "pointer"
      }} 
    >
      <Typography sx={{fontFamily: "NanumSquareBold", fontSize:"1.25rem", lineHeight: "1.25rem", marginBottom: "4px"}}>{noteName}</Typography>
      <Typography sx={{fontFamily: "NanumSquareBold", fontSize:"0.625rem", lineHeight: "0.625rem", color: "gray", marginBottom: "8px"}}>{noteId}</Typography>
      <Box sx={{
        display: "flex",
        alignItems: "center",
        justifyContent: "space-between",
        "& div": {
          fontFamily: "NanumSquareExtraBold",
          fontSize:"0.875rem"
        }
      }}>
        <div>💵&nbsp;{balance.toLocaleString()}</div>
        <div>{otherUser}</div>
      </Box>
    </Card>
  );
}

function NoteGroupSkeleton() {
  return (
    <Skeleton
      variant="rounded"
      animation="wave"
      height={95}
    />
  );
}

function EmptyList({text}) {
  return (
    <div
      style={{
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
        height: "50px",
        boxSizing: "border-box",
        color: "gray"
      }} 
    >
      {text}
    </div>
  )
}

const GroupContainer = styled("div")({
  display: "grid",
  gap: "2rem 1rem"
});

const GroupLabel = styled("div")({
  marginBottom: "6px",
  fontFamily: "NanumSquareExtraBold"
});